import React, { useEffect, useState } from 'react';
import { BiExpand } from "react-icons/bi";
import { RiCloseLine } from "react-icons/ri";
import styled, { css } from "styled-components";
import { UiConstants } from "../../data/UiConstants";
import { dataConstants } from "../../../shared/data/dataConstants";
import { localStorageGetNumber, localStorageSetNumber } from '../../integration/localStorage';
export let Adjustment;

(function (Adjustment) {
  Adjustment[Adjustment["Top"] = 0] = "Top";
  Adjustment[Adjustment["Right"] = 1] = "Right";
  Adjustment[Adjustment["Bottom"] = 2] = "Bottom";
  Adjustment[Adjustment["Left"] = 3] = "Left";
})(Adjustment || (Adjustment = {}));

export let State;

(function (State) {
  State[State["Expanded"] = 0] = "Expanded";
  State[State["Collapsed"] = 1] = "Collapsed";
  State[State["NotSet"] = 2] = "NotSet";
})(State || (State = {}));

const Container = styled.div.attrs(props => props).withConfig({
  displayName: "SlideMenu__Container",
  componentId: "sc-9z80k1-0"
})(["z-index:", ";right:", ";left:", ";top:", ";bottom:", ";width:", ";height:", ";max-width:", ";max-height:", ";overflow:", ";position:absolute;", ""], props => props.zIndex, props => props.right, props => props.left, props => props.top, props => props.bottom, props => props.width, props => props.height, props => props.maxWidth, props => props.maxHeight, props => props.overflow, props => props.animated && css(["transition:250ms;"]));
const Button = styled.div.attrs(props => props).withConfig({
  displayName: "SlideMenu__Button",
  componentId: "sc-9z80k1-1"
})(["background-color:#FFFFFF;text-align:center;&:hover{color:grey;cursor:pointer;}&.hidden{display:none;}"]);
const OpenButton = styled(Button).withConfig({
  displayName: "SlideMenu__OpenButton",
  componentId: "sc-9z80k1-2"
})(["height:", ";width:", ";font-size:", ";border-radius:", ";border:solid 2px black;overflow:hidden;display:flex;align-items:center;justify-content:center;"], UiConstants.SIZE_SLIDE_MENU_ICON, UiConstants.SIZE_SLIDE_MENU_ICON, UiConstants.SIZE_SLIDE_MENU_ICON_FONT, UiConstants.BORDER_RADIUS);
const CloseButton = styled(Button).withConfig({
  displayName: "SlideMenu__CloseButton",
  componentId: "sc-9z80k1-3"
})(["z-index:20000;height:", ";width:", ";font-size:", ";position:absolute;margin-top:-1px;border-bottom-left-radius:", ";border-top-right-radius:", ";border:1px solid black;top:", "px;right:", "px;background:#F7E400;"], UiConstants.SIZE_SLIDE_MENU_CLOSE_ICON, UiConstants.SIZE_SLIDE_MENU_CLOSE_ICON, UiConstants.SIZE_SLIDE_MENU_CLOSE_ICON_FONT, UiConstants.BORDER_RADIUS, UiConstants.BORDER_RADIUS, props => props.offsetY || 0, props => props.offsetX || 0);
export const Menu = styled.div.attrs(props => props).withConfig({
  displayName: "SlideMenu__Menu",
  componentId: "sc-9z80k1-4"
})(["width:", ";height:", ";display:none;", " overflow-y:", ";overflow-x:", ";&.expanded{display:block;}"], props => props.width, props => props.height, props => !props.transparent && css(["background:", ";border:solid 1px #274237;border-radius:", ";"], props.backgroundColor ? props.backgroundColor : dataConstants.isDevelopment ? '#CCCCDF' : '#E4E2D5', UiConstants.BORDER_RADIUS), props => props.overflow, props => props.overflow);
const Content = styled.div.withConfig({
  displayName: "SlideMenu__Content",
  componentId: "sc-9z80k1-5"
})(["margin:2px;height:", ";"], props => props.height);

function rawInputToCSS(input) {
  if (input === undefined || input === null) return "";
  if (typeof input === "number") return input + "px";
  return input;
}

export const SlideMenu = props => {
  var _props$containerOverf, _props$icon;

  const usePersistence = !props.ignorePersistedExpansionState && props.collapsible;
  const storageKey = "slideMenu_" + props.identifier;
  const defaultState = usePersistence ? localStorageGetNumber(storageKey, props.state) : props.state;
  const [state, setState] = useState(defaultState);
  const expanded = !props.collapsible || state === State.Expanded;

  const onUserToggle = () => {
    const stateNow = expanded ? State.Collapsed : State.Expanded;
    setState(stateNow);

    if (usePersistence) {
      localStorageSetNumber(storageKey, stateNow);
    }

    if (props.onUserToggle) {
      props.onUserToggle(stateNow);
    }
  };

  const containerWidth = expanded ? rawInputToCSS(props.width) : UiConstants.SIZE_SLIDE_MENU_ICON;
  const containerHeight = expanded ? rawInputToCSS(props.height) : UiConstants.SIZE_SLIDE_MENU_ICON;
  const containerMaxWidth = expanded ? rawInputToCSS(props.maxWidth) : undefined;
  const containerMaxHeight = expanded ? rawInputToCSS(props.maxHeight) : undefined;
  const containerOverflow = (_props$containerOverf = props.containerOverflow) !== null && _props$containerOverf !== void 0 ? _props$containerOverf : containerMaxWidth || containerMaxHeight ? "auto" : undefined;
  const icon = (_props$icon = props.icon) !== null && _props$icon !== void 0 ? _props$icon : /*#__PURE__*/React.createElement(BiExpand, null);
  const isVerticalMenu = props.orientation == Adjustment.Left || props.orientation == Adjustment.Right;
  let start = props.start;

  if (!start) {
    start = 0;
  }

  if (typeof start === "number") {
    start = start + "px";
  }

  if (!expanded && props.iconStart !== undefined) {
    start = props.iconStart + "px";
  }

  let containerTop;
  let containerBottom;
  let containerLeft;
  let containerRight;

  if (isVerticalMenu) {
    containerTop = start;
    containerLeft = props.orientation == Adjustment.Right ? "" : "0px";
    containerRight = props.orientation == Adjustment.Right ? "0px" : "";
  } else {
    containerLeft = start;
    containerTop = props.orientation == Adjustment.Bottom ? "" : "0px";
    containerBottom = props.orientation == Adjustment.Bottom ? "0px" : "";
  }

  const menuOverflow = props.menuOverflow || "auto";
  useEffect(() => {
    if (props.openMenuTriggerValue) setState(State.Expanded);
  }, [props.openMenuTriggerValue]);
  const {
    zIndex
  } = props;
  return /*#__PURE__*/React.createElement(Container, {
    zIndex: zIndex === undefined ? UiConstants.Z_INDEX_SLIDE_MENU : zIndex,
    top: containerTop,
    left: containerLeft,
    right: containerRight,
    bottom: containerBottom,
    width: containerWidth,
    height: containerHeight,
    maxWidth: containerMaxWidth,
    maxHeight: containerMaxHeight,
    overflow: containerOverflow,
    animated: !props.notAnimated
  }, /*#__PURE__*/React.createElement(OpenButton, {
    className: expanded ? 'hidden' : '',
    onClick: onUserToggle
  }, icon), (expanded || props.renderEvenWhenClosed) && /*#__PURE__*/React.createElement(Menu, {
    className: expanded ? 'expanded' : '',
    height: "100%",
    width: "100%",
    overflow: menuOverflow,
    backgroundColor: props.menuBackgroundColor,
    transparent: props.transparent
  }, props.collapsible && /*#__PURE__*/React.createElement(CloseButton, {
    offsetX: props.closeButtonOffsetX,
    offsetY: props.closeButtonOffsetY
  }, /*#__PURE__*/React.createElement(RiCloseLine, {
    onClick: onUserToggle
  })), /*#__PURE__*/React.createElement(Content, {
    height: props.contentHeight
  }, props.children)));
};